import { useEffect, useState } from 'react';

import { FEATURE_FLAGS } from '@/lib/feature-flags';
import { getFeatureFlag } from '@/lib/mixpanel';
import { useAuth0 } from '@auth0/auth0-react';

/** Unknown assignments stay closed, and an account change discards the old one. */
export function useSmartOfferRedesignState(): boolean | null {
  const { user } = useAuth0();
  const identity = user?.sub;
  const [assignment, setAssignment] = useState<{
    identity: string | undefined;
    enabled: boolean | null;
  }>(() => ({
    identity,
    // Mixpanel's sync cache may still belong to the previous identity.
    enabled: null,
  }));

  useEffect(() => {
    let active = true;
    // Auth wrappers identify the user in an effect. Read after those effects
    // so Mixpanel has started loading the assignment for the new identity.
    void Promise.resolve()
      .then(() => getFeatureFlag(FEATURE_FLAGS.smartOfferRedesign))
      .then((enabled) => {
        if (active) setAssignment({ identity, enabled: enabled === true });
      })
      .catch(() => {
        if (active) setAssignment({ identity, enabled: false });
      });
    return () => {
      active = false;
    };
  }, [identity]);

  return assignment.identity === identity ? assignment.enabled : null;
}

export function useSmartOfferRedesign(): boolean {
  return useSmartOfferRedesignState() === true;
}
